export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/accountingProvider/state.js